import React, { useEffect, useRef, useState } from 'react';
import styled from "styled-components"
import { useDispatch, useSelector } from "react-redux";
import Share from "../../components/share/newShare/index";
import OptionModal from "./optionModal";
import { itemAPI } from "../../components/api/common"
import CompareViewTop from "./compareViewTop";
import CompareViewBottom from "./compareViewBottom";
import { SET_COMPARE_VIEW } from "../../libs/action";
import { BottomArrowIcon } from "../../assets/Icons";
import {useRouteMatch} from "react-router-dom";

/**
 * 상품사양비교 새창
 * @returns {JSX.Element}
 * @constructor
 */
const CompareView = () => {
    const dispatch = useDispatch()
    const match = useRouteMatch('/compare_spec/:catgegory_id/:item_id')
    const urlSearchCateId = match.params.catgegory_id
    const urlSearchItemId = decodeURIComponent(match.params.item_id)

    const { compareView } = useSelector(state => state.estimateAdd)

    if (compareView.length === 0) {
        window.close()
    }

    const topElementHeight = 420
    let bottomElementHeight = window.innerHeight - topElementHeight
    let bottomElementWidth = window.innerWidth

    const optionModal = useRef(null)
    const topTableRef = useRef(null)
    const refs = {
        bottomTableRef:useRef(null),
        bottomLeftTableRef:useRef(null)
    }
    const [isOpenOptionModal, setIsOpenOptionModal] = useState(false)
    const [isPrinting, setIsPrinting] = useState(false);
    const [bottomSize, setBottomSize] = useState({
        height: bottomElementHeight,
        width: bottomElementWidth - 28
    })
    const [isHighlight, setIsHighlight] = useState(false)
    const [isOptionButtonActive, setIsOptionButtonActive] = useState(false)
    const [isDifferenceButtonActive, setDifferenceIsButtonActive] = useState(false)
    const [isPageLoading, isSetPageLoading] = useState(true)
    const [checkedList, setCheckedList] = useState([]);
    const [urlItemId, setUrlItemId] = useState(urlSearchItemId)

    let itemSpec = compareView[0]?.spec[0]?.child || [] // 상품제원
    let itemDetailedSpec = compareView[0]?.spec[1]?.child || [] // 지원 및 상세제원

    const hideGNB = () => {
        document.getElementById("header").style.display = 'none'
        document.getElementById("footer").style.display = 'none'
        document.getElementsByTagName("body")[0].style.overflow = 'hidden'
    }

    const callItemCompareListApi = () => {
        itemAPI.getItemCompareList(urlSearchCateId, urlSearchItemId.replaceAll(',','|')).then((rst) => {
            if (rst.status === 200) {
                let result = rst.data.result.itemList
                dispatch({
                    type: SET_COMPARE_VIEW,
                    compareView: result
                })
                isSetPageLoading(false)
            }
        })
    }

    const printItems = () => {
        if (isPageLoading) return false
        setIsPrinting(true)
        const bottomLeftTap = document.querySelector(".fix_scroll")
        const scrollXList = document.querySelector(".scroll_x")
        const moveBtnList = document.querySelectorAll(".move_product_btn")

        bottomLeftTap.style.height = "auto"
        scrollXList.style.height = "auto"
        scrollXList.style.overflow = "hidden"

        moveBtnList.forEach(v => {
            v.style.display = "none"
        })
        setBottomSize({
            height: window.innerHeight - topElementHeight,
            width: window.innerWidth - 28
        })

        setTimeout(() => {
            window.print()
        },[100])
    }

    const handlePrintAfter = () => {
        const bottomLeftTap = document.querySelector(".fix_scroll")
        const scrollXList = document.querySelector(".scroll_x")
        const moveBtnList = document.querySelectorAll(".move_product_btn")

        bottomLeftTap.style.height = `${bottomSize.height}px`
        moveBtnList.forEach(v => {
            v.style.display = "block"
        })
        scrollXList.setAttribute("style", `height: ${(window.innerHeight - topElementHeight) + 17}px; width: ${bottomSize.width - 72}px; overflow-x: scroll;`)

        setTimeout(() => {
            setIsPrinting(false)
        },[50])
    }


    const handleBrowserResize = () => {
        setBottomSize({
            height: window.innerHeight - topElementHeight,
            width: window.innerWidth - 28
        })
    }

    const handleOpenOptionModal = () => {
        if (isPageLoading) return false
        setIsOpenOptionModal(!isOpenOptionModal)
        setIsOptionButtonActive(!isOptionButtonActive)
    }

    const handleCloseOptionModal = () => {
        if (isOpenOptionModal) {
            setIsOpenOptionModal(false)
            setIsOptionButtonActive(false)
        }
    }

    const handleInfoHighlight = () => {
        if (isPageLoading) return false
        setIsHighlight(!isHighlight)
        setDifferenceIsButtonActive(!isHighlight)

        if (!isHighlight) {
            const element = document.querySelectorAll(".compare_list_tr_0")
            element.forEach((_,__) => {
                const elementLength = element[0].children.length - 1
                for (let j = 0; j <= elementLength; j++){
                    let result = document.querySelectorAll(`.${element[0].children[j].className}`)
                    let itemResult = []
                    result.forEach((v,i) => {
                        if (v.className !== "scroll_list"){
                            if (i === 0){
                                itemResult = []
                            } else if (i === result.length - 1) {
                                itemResult.push(v.innerHTML)
                                const redundantArray = itemResult.filter((v,i) => (
                                    itemResult.indexOf(v) === i
                                ))
                                if (redundantArray.length > 1) {
                                    result.forEach(v => {
                                        v.className += " highlight"
                                    })
                                }
                            } else {
                                itemResult.push(v.innerHTML)
                            }
                        }
                    })
                }
            })
        } else {
            const allHighlight = document.querySelectorAll(".highlight")
            allHighlight.forEach(v => {
                v.classList.remove("highlight")
            })
        }
    }

    const handleScrollBottom = (scroll) => {
        if (topTableRef.current) {
            refs.bottomLeftTableRef.current.scrollTop = scroll.target.scrollTop;
            topTableRef.current.scrollLeft = scroll.target.scrollLeft;
        }
    };

    useEffect(() => {
        hideGNB()
        callItemCompareListApi()
    },[])

    useEffect(() => {
        window.addEventListener("resize", handleBrowserResize)
        return () => {
            window.removeEventListener("resize", handleBrowserResize)
        }
    },[])

    useEffect(() => {
        window.addEventListener("afterprint", handlePrintAfter)
        return () => {
            window.removeEventListener("afterprint", handlePrintAfter)
        }
    },[])

    return (
        <Wrapper>
            {isOpenOptionModal &&
                <OptionModal
                    onClose={handleCloseOptionModal}
                    ref={optionModal}
                    itemSpec={itemSpec}
                    itemDetailedSpec={itemDetailedSpec}
                    checkedList={checkedList}
                    setCheckedList={setCheckedList}
                />
            }
            <TitleWrapper>
                <div className="compareView_title_area">
                    <span>상품사양 비교</span>
                    {!isPrinting &&
                        <>
                            <PrinterButton type="button" onClick={printItems}>
                                <i className="icon-printer"></i>
                            </PrinterButton>
                            <div className="layer_group_field">
                                <Share />
                            </div>
                        </>
                    }
                </div>
            </TitleWrapper>
            {!isPrinting &&
                <CompareViewFilter>
                    <button className={isOptionButtonActive? 'compareView_option active':'compareView_option'} onClick={handleOpenOptionModal}>
                        <div>
                            <span>옵션</span>
                            <BottomArrowIcon color={isOptionButtonActive? '#3281ed' : '#666666'}/>
                        </div>
                    </button>
                    <button className={isDifferenceButtonActive? 'compareView_difference active' : 'compareView_difference'} onClick={handleInfoHighlight}>
                        차이점 강조
                    </button>
                </CompareViewFilter>
            }
            {isPageLoading
                ? (
                    <Loading>
                        <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v5/happy_loading_5.gif`} alt="" width="60" height="69" />
                    </Loading>
                ):(
                    <CompareViewContents id="item_compare_contents">
                        <CompareViewTop
                            itemList={compareView}
                            isPrinting={isPrinting}
                            urlSearchCateId={urlSearchCateId}
                            ref={topTableRef}
                            urlItemId={urlItemId}
                            setUrlItemId={setUrlItemId}
                            bottomSize={bottomSize}
                        />
                        <CompareViewBottom
                            itemList={compareView}
                            bottomSize={bottomSize}
                            itemSpec={itemSpec}
                            ref={refs}
                            handleScrollBottom={handleScrollBottom}
                        />
                    </CompareViewContents>
                )
            }
        </Wrapper>
    );
};

export default CompareView;

const TitleWrapper = styled.div`
    height: 60px;
    background-color: #333333;
    color: #ffffff;
    font-size: 22px;
    font-family: 'Noto Sans KR';
    font-weight: bold;

    .compareView_title_area {
        display: flex;
        padding: 15px 30px;
    }
    .share_btn_wrapper {
        background-color: #333333;
    }
    .share_btn {
        position: absolute;
        right: 30px;
        top: 10px;
        background-color: #333333;
    }
`;

const CompareViewFilter = styled.div`
    height: 30px;
    background-color: #f7f7f7;
    border-bottom: 1px solid #e5e5e5;
    display: flex;
    padding-top: 13px;
    padding: 10px 30px;
    font-family: 'Noto Sans KR';
    color: #666666;
    font-size: 10px;
    button {
        color: #666666;
        font-size: 12px;
    }
    span {
      padding-right: 22px;
    }
    .compareView_option_arrow tspan {
        fill: #666666;
    }
    .compareView_option_arrow.active tspan {
      fill: #3281ed;
    }
    .compareView_option.active {
        border: 1px solid #3281ed;
        color: #3281ed;
        &:hover {
            border: 1px solid #3281ed;
        }
    }
    .compareView_option {
        height: 27px;
        display: inline-block;
        padding: 4px 9px 5px 12px;
        border: 1px solid #999999;
        background-color: #ffffff;
        margin-right: 8px;
        border-radius: 22px;

        &:hover {
            background-color: #f6f6f6;
            border: 1px solid #999999;
        }
    }
    .compareView_difference.active {
        border: 1px solid #3281ed;
        color: #3281ed;
        &:hover {
            border: 1px solid #3281ed;
        }
    }
    .compareView_difference {
        height: 27px;
        display: inline-block;
        padding: 4px 15px;
        border: 1px solid #999999;
        background-color: #ffffff;
        border-radius: 22px;
        &:hover {
            background-color: #f6f6f6;
            border: 1px solid #999999;
        }
    }
`;

const CompareViewContents = styled.div`
    padding: 30px 25px;

    .pname {
        font-weight: 500;
        &:hover {
            text-decoration: underline;
        }
    }
    .fix_x_scroll {
        position: relative;
        height: 100%;
        width: 100%;
        overflow-x: scroll;
        display: flex;
    }
    .fix_data_top {
        overflow: hidden;
    }
    .fix_area_bottom {
        table {
            td.highlight {
                background-color: #f2f8ff;
            }
        }
    }
    .comp_table {
        table-layout: fixed;
        border-collapse: separate;
        border-spacing: 0;
        margin: 0 auto;
        border-bottom: 1px solid #757575;
    }
    .pop_fix_table {
        margin: 0;
        border-top: 1px solid #757575;
        border-collapse: collapse;
    }
    .fix_head_top {
        width: 100%;
    }
    .fix_area_top {
        position: relative;
        height: 263px;
        overflow: hidden;
        z-index: 2;

        .fixed_table .fix_head {
            position: absolute;
            top: 0;
            left: 0;
            width: 79px;
            overflow: hidden;
            height: 100%;
            border-right: 1px solid #757575;
            z-index: 1;

            .fix_scroll .scroll_head_top {
                overflow: hidden;
            }
        }
    }
    .fix_area_bottom {
        height: auto;
    }
    .item_compare_thumnail {
        width: 180px !important;
        padding: 15px 0;
    }
    .item_price {
        strong {
            font-family: 'Noto Sans KR';
            color: #e23714;
            margin-right: 1px;
            font-size: 15px;
            font-weight: bold;
        }
        span {
            color: #999999;
        }
    }
    .pimg {
        width: 110px;
        height: 110px;
        display: block;
        margin: 0 auto;
        img {
            max-width: 100%;
            &:hover {
                color: #3281ed;
                border: 1px solid #3281ed;
            }
        }
    }
`;

const PrinterButton = styled.button`
    position: absolute;
    right: 75px;
    top: 10px;
    background-color: #333333;
    display: flex;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border: 1px solid #fff;
    padding: 0px 0 0 6px;
    width: 36px;
    height: 36px;
    border-radius: 18px;
    color: #fff;
    cursor: pointer;

    &:hover {
        color: #3281ed;
        border: 1px solid #3281ed;
    }
`;

const Wrapper = styled.div`
    font-family: 'Noto Sans KR';
    .option_wrap::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera*/
    }
    .fix_scroll.scroll_head_top::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera*/
    }
    .scroll_head_top_flex::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera*/
    }
    .scroll_x {
        overflow-x: scroll;
    }
`;

const Loading = styled.div`
    display: flex;
    width: 100%;
    height: 500px;
    align-items: center;
    justify-content: center;
`



// WEBPACK FOOTER //
// ./src/estimate_list/components/compareview/index.js